<ix-page-header [title]="'Dashboard' | translate" [loading]="isLoading()">
  @if (!isEditing()) {
    <button
      *ixNewFeatureIndicator="newFeatureConfig"
      mat-button
      color="primary"
      ixTest="configure-dashboard"
      [ixUiSearch]="searchableElements.elements.configure"
      [disabled]="isLoading()"
      (click)="onConfigure()"
    >
      {{ 'Configure' | translate }}
    </button>
  }
</ix-page-header>

@if (isEditing()) {
  <div class="edit-mode-buttons">
    @if (customLayout()) {
      <button
        mat-button
        type="button"
        ixTest="reset"
        [disabled]="isLoading()"
        [matTooltip]="'Restore default set of widgets' | translate"
        (click)="onReset()"
      >
        {{ 'Reset' | translate }}
      </button>
    }

    <button
      mat-button
      class="add-button"
      ixTest="add-group"
      [disabled]="isLoading()"
      (click)="onAddGroup()"
    >
      {{ 'Add' | translate }}
    </button>
    <button
      mat-button
      color="primary"
      ixTest="save"
      [disabled]="isLoading()"
      (click)="onSave()"
    >
      {{ 'Save' | translate }}
    </button>
    <button
      mat-button
      ixTest="cancel"
      [disabled]="isLoading()"
      (click)="onCancelConfigure()"
    >
      {{ 'Cancel' | translate }}
    </button>
  </div>
}

@if (isLoadingFirstTime()) {
  <ngx-skeleton-loader
    class="groups loading"
    [count]="6"
    [theme]="{ background: 'var(--alt-bg2)', opacity: 0.25, margin: 0 }"
  ></ngx-skeleton-loader>
} @else {
  <div
    class="groups"
    ixDropGrid
    [ixDropGridModel]="renderedGroups()"
    [ixUiSearch]="searchableElements.elements.dashboard"
    (ixDropGridModelChange)="onGroupsReordered($event)"
  >
    @if (renderedGroups().length > 0) {
      <div
        *ngFor="let group of renderedGroups(); index as i; trackBy: trackByFn"
        class="group-slot"
        ixDropGridItem
        @groupRemovedTrigger
      >
        <div
          ixDrag
          class="group-container"
          [class.editing]="isEditing()"
        >
          <ix-widget-group-controls
            class="controls"
            [index]="i"
            [totalGroups]="renderedGroups().length"
            [disableFocusableElements]="!isEditing()"
            (moveUp)="onMoveGroup(i, -1)"
            (moveDown)="onMoveGroup(i, 1)"
            (edit)="onEditGroup(i)"
            (delete)="onDeleteGroup(group)"
          ></ix-widget-group-controls>

          <ix-widget-group
            class="group"
            [disableFocusableElements]="isEditing()"
            [group]="group"
          ></ix-widget-group>
        </div>
      </div>
    } @else {
      <ix-empty [conf]="emptyDashboardConf"></ix-empty>
    }
  </div>
}


